export const addresses = {
  dotNounsArt: "0x4EA1b6958765447B9A6Be1E9AEF42Ad756c3cf36",
};
